import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import StartPrintDialog from '../../StartPrintDialog';
import { generateJobId } from '../../utils/printJobs';
import { showToastError } from '../../components/ToastNotifications';
import { useLegacyAppSession } from '../../contexts/LegacyAppSessionContext';
import { useRestoredPrintPackage } from '../../hooks/usePackages';
import { useDeleteDraftPrintRun } from '../../hooks/usePrintRuns';

export default function NewPrintContainer() {
  const location = useLocation();
  const navigate = useNavigate();
  const { currentUser, org } = useLegacyAppSession();
  const organizationId = org?.id == null ? undefined : Number(org.id);
  const { deleteDraft, isDeletingDraft } = useDeleteDraftPrintRun(organizationId);
  const packageId = location.state?.pkg?.id ?? null;
  const {
    data: initialPackage,
    isLoading: isPackageLoading,
    error: packageError,
    retry: retryPackage,
  } = useRestoredPrintPackage(org?.id, { packageId });

  useEffect(() => {
    if (packageError) {
      showToastError('Package could not be loaded.');
    }
  }, [packageError]);

  // The dialog must never open with a package identity it cannot fully populate.
  if (isPackageLoading) return null;
  if (packageError) {
    return (
      <div role="alert">
        <p>Package could not be loaded.</p>
        <button type="button" onClick={retryPackage}>Retry</button>
        <button type="button" onClick={() => navigate('/prints', { replace: true })}>Back to Print Runs</button>
      </div>
    );
  }

  return (
    <StartPrintDialog
      key={location.key}
      defaultJobId={generateJobId()}
      initialValues={location.state?.pkg ? { packageId: location.state.pkg.id } : undefined}
      initialPackage={initialPackage}
      onClose={() => navigate('/prints', { replace: true })}
      onSave={async () => {
        navigate('/prints', { replace: true });
      }}
      onDeleteDraft={deleteDraft}
      isDeletingDraft={isDeletingDraft}
      organizationId={organizationId}
      currentUser={currentUser}
    />
  );
}
